import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Manuscript } from './pages/Manuscript';
import { legalDocs } from './data/legal';
import { Credits } from './pages/Credits';
import { creditDocs } from './data/credits';
import { useSmoothScroll } from './hooks/useSmoothScroll';
type AppProps = {
  heroHover?: 'trail' | 'ripple' | 'lens' | 'dissolve' | 'magnet';
};
export function App({
  heroHover = 'trail'
}: AppProps) {
  useSmoothScroll();
  return <BrowserRouter data-id="element-0" data-mp="2wiyv4mpflj91">
      <div className="w-full bg-mist-bg font-sans" data-id="element-1" data-mp="2wip5x1c7ng4e">
        <Header data-id="element-2" data-mp="28tw4ipctkg2e" />
        <main data-id="element-3" data-mp="28te2td7e19n3">
          <Routes data-id="element-4" data-mp="28suu8n3mnxlq">
            <Route path="/" element={<Home heroHover={heroHover} data-id="element-6" data-mp="23vcikoy874a1" />} data-id="element-5" data-mp="28sbcb6dz997p" />
            <Route path="/manuscript" element={<Manuscript data-id="element-8" data-mp="23t8eo70bu59r" />} data-id="element-7" data-mp="23ujmchww7x65" />
            {legalDocs.map(d => <Route key={d.slug} path={`/${d.slug}`} element={<Legal doc={d} data-id="element-10" data-mp="3mlj8uuvtnd32" />} data-id="element-9" data-mp="3ij61y35c994p" />)}
            {creditDocs.map(d => <Route key={d.slug} path={`/${d.slug}`} element={<Credits doc={d} data-id="element-12" data-mp="3rdaselgk8ijp" />} data-id="element-11" data-mp="3mj6j3vjtnyfg" />)}
            <Route path="*" element={<Navigate to="/" replace data-id="element-14" data-mp="6hrlipoilfp" />} data-id="element-13" data-mp="3relvsk63foaa" />
          </Routes>
        </main>
        <Footer data-id="element-15" data-mp="7sxbo2oq39g" />
        <CookieBanner data-id="element-16" data-mp="2zld1r8m3ndb0" />
      </div>
    </BrowserRouter>;
}